<template>


    <div>
        <label :for="id" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-right">
            {{ label }}
        </label>
        <select :id="id" v-bind="$attrs" v-model="model"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary disabled:bg-white disabled:cursor-default focus:shadow-xl transition-all">
            <option v-for="item in items" :value="item[itemValue]">{{ item[itemLabel] }}</option>
        </select>

    </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { uniqueId } from 'lodash';
import { toRefs } from 'vue';

const id = uniqueId()


const props = withDefaults(
    defineProps<{
        label?: string,
        modelValue?: any,
        items: any[],
        itemValue?: string,
        itemLabel?: string,

    }>(), {

    itemValue: 'value',
    itemLabel: 'label',
}
)

const { items } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const model = useVModel(props, 'modelValue', emit)


</script>

<style scoped></style>